export const useMobileCheck = () => {
	return window.matchMedia("(max-width: 600px)").matches;
};
